module.exports = ol.source.WMTS;